import { slugifyHeading } from '@/utils/glossary-toc';
import VisibleLoading from '@/components/utilities/VisibleLoading';

const SEGMENT_CLASSES = {
  champions: 'bg-green-50 border-green-200',
  loyal: 'bg-blue-50 border-blue-200',
  atrisk: 'bg-yellow-50 border-yellow-200',
  sleeping: 'bg-grey-100 border-grey-200',
  new: 'bg-purple-50 border-purple-200'
};

const SegmentCard = ({ segment }) => {
  const colorClass = SEGMENT_CLASSES[segment.segmentColor] || SEGMENT_CLASSES.sleeping;

  return (
    <div className={`rounded-2xl border px-5 py-4 ${colorClass} ${segment.isWide ? 'sm:col-span-2' : ''}`}>
      <div className="mb-1 text-[15px] font-bold">{segment.name}</div>
      {segment.rfmCode && <div className="mb-2 text-xs font-semibold tracking-wider opacity-70">{segment.rfmCode}</div>}
      {segment.action && <div className="text-[13px] leading-relaxed">{segment.action}</div>}
    </div>
  );
};

const GlossarySegmentsShowcase = ({ title, description, segments = [] }) => {
  if (segments.length === 0 && !title) return null;

  const headingId = title ? slugifyHeading(title) : undefined;

  return (
    <section className="my-2">
      {title && (
        <VisibleLoading delay={100}>
          {({ ref, className }) => (
            <h2 id={headingId} ref={ref} className={`mb-4 ${className || ''}`.trim()}>
              {title}
            </h2>
          )}
        </VisibleLoading>
      )}

      {description && <p className="text-grey-600 mb-6 leading-relaxed">{description}</p>}

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        {segments.map((segment) => (
          <SegmentCard key={segment.id} segment={segment} />
        ))}
      </div>
    </section>
  );
};

export default GlossarySegmentsShowcase;
